import React, { PureComponent } from 'react';
import { isEmpty } from 'lodash/fp';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import Select from 'components/shared/select';

function safelyParseJSON(value) {
  let parsed;
  try {
    parsed = JSON.parse(value);
  } catch (error) {} // eslint-disable-line
  return parsed; // could be undefined
}

class GroupFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.groupId || '',
      loading: true,
      groups: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  nodeRoot = React.createRef();

  componentDidMount() {
    this.fetchGroups();
  }

  fetchGroups() {
    request.get(routes.GROUPS).then(({ groups }) => {
      if (this.nodeRoot.current) {
        /**
         * Can't set `groups` and `loading` at the same time. Why?
         * Well, Firefox doesn't set the option that matches the selected id
         * after fetching the groups. So I had to set the groups and then render
         * the Select. After an hour of debugging, it seems like the extra
         * re-render would fix the problem. Even IE doesn't have this problem!
         */
        this.setState({ groups }, () => {
          this.setState({ loading: false });
        });
      }
    });
  }

  handleChange(e) {
    const value = safelyParseJSON(e.target.value);
    this.setState({ value });
    this.props.onChange(value || null);
  }

  renderGroups() {
    const { loading, groups } = this.state;
    if (loading) {
      return <option>Loading</option>;
    }
    return [
      <option key="none" value="">
        {t('groups.select')}
      </option>,
      ...groups.map(({ id, name }) => (
        <option key={id} value={id}>
          {name}
        </option>
      )),
    ];
  }

  render() {
    const { loading, groups } = this.state;
    if (!loading && isEmpty(groups)) return false;
    return (
      <div className="d-f ai-c" ref={this.nodeRoot}>
        <div className="f-sh-0 mr-8 c-gray-darker">{t('common.filter_by')}</div>
        <Select
          value={this.state.value}
          onChange={this.handleChange}
          disabled={this.state.loading}
          className="w-240"
          children={this.renderGroups()}
        />
      </div>
    );
  }
}

export default GroupFilter;
